import React from 'react';

export const GalleryArtEligibilityNotice = ({ compact = false }) => (
  <section aria-label="Representational art requirement" className="my-5 rounded border-2 border-[#7c2434] bg-white p-5 text-lg leading-8 text-[#17243d]">
    <p className="font-semibold">Representational art only</p>
    {compact ? (
      <p className="mt-2">Please submit artwork that depicts recognizable subjects. Abstract and nonrepresentational artwork is not eligible for the Member Holiday Show or Ongoing Gallery Rotations.</p>
    ) : (
      <p className="mt-2">In keeping with the Coppini Academy’s bylaws and the founding principles established by Pompeo Coppini, all submitted artwork must be representational, depicting recognizable subjects. Abstract and nonrepresentational artwork is not eligible for either the Member Holiday Show or Ongoing Gallery Rotations. Thank you for helping us honor this tradition.</p>
    )}
  </section>
);
